export default __webpack_public_path__ + "static/media/Educational Course.c8bf78d2.jpg";